// const userServices = `production-service/reel/api/v1/`
const endPoints = {
  login: `user-service/reel/api/v1/user/login`,
  logout: `/user-service/reel/api/v1/user/logout`,
  deactivateAccount: `/user-service/reel/api/v2/user/deactivate`,
  register: `user-service/reel/api/v1/user/signup`,
  resetOTP: '/user-service/reel/api/v1/user/resendOtp',
  forget_password: '/forgot-password',
  resetpassword: 'reset-password',
  change_password: 'change-password',
  getPresignedUrl: '/user-service/reel/api/v1/user/preSignedUrl',
  updateProfile: 'profile',
  deleteDoc: '/production-service/reel/api/v2/documents',
  studiodashcards: '/production-service/reel/api/v2/web/studio/',
  getProfile: 'admin-details',
  staticRoles: '/production-service/reel/api/v1/static-roles',
  template: 'template',
  departments: '/production-service/reel/api/v1/departments',
  assosiatedEntities: '/user-service/reel/api/v1/user/associated_entities',
  uploadDocument: 'production-service/reel/api/v2/document',
  addCrewContact: 'production-service/reel/api/v1/member',
  getProductDetails: 'shop-service/reel/api/v1/app/product/',
  getMultipleSetsLocationData:
    'production-service/reel/api/v1/locations/associated-sets',

  addDepartment: '/production-service/reel/api/v2/dept',
  // updateCrewMember: '/production-service/reel/api/v1/member/',
  updateCrewMember: '/production-service/reel/api/v2/member/',
  departmentlist: 'user-service/reel/api/v2/user/dept-list',
  roleList: 'user-service/reel/api/v2/user/role-list',
  userdetailssignUp: 'user-service/reel/api/v1/user/user-details',
  departmentsList: '/production-service/reel/api/v1/departments',
  LeaveEntity: 'user-service/reel/api/v2/user/leave-entity/',
  editProfile: 'user-service/reel/api/v2/user/edit-profile',
  departmentsLists: '/production-service/reel/api/v2/manage-dept-list',
  manageEntitiesAccess:
    '/production-service/reel/api/v2/manage-entities/access',
  manageEntitiesTransferOwnership:
    '/production-service/reel/api/v2/manage-entities/transfer-ownership',
  manageEntitiesBulkRemoveAccess:
    '/production-service/reel/api/v2/manage-entities/access/bulk-remove',
  permissions: '/production-service/reel/api/v2/user-permissions',
  markDefault: '/production-service/reel/api/v1/mark-as-default',
  requestEntityList: '/production-service/reel/api/v1/web/request-entity',
  requestEntityDetail: '/production-service/reel/api/v1/request-entity-detail',
  sendRequest: '/production-service/reel/api/v1/request',
  dashboardAccess: '/production-service/reel/api/v1/user-permission-dashboard',
  userPermission: '/user-service/reel/api/v2/user/',
  accessControl: '/user-service/reel/api/v1/user/message-setting',
  checkPONumber: '/production-service/reel/api/v1/check-po-number',
  memberUnique: '/production-service/reel/api/v2/member-unique-check',
  actualEstimateGraph: '/shop-service/reel/api/v2/spending/graph',
  productionListweb: (page = 1, limit = 10, searchKey = '') => {
    const searchQuery = searchKey ? `&searchKey=${searchKey}` : '';
    return `production-service/reel/api/v1/web/productions?page=${page}&limit=${limit}${searchQuery}`;
  },
  webEpisodes: '/production-service/reel/api/v1/web/episodes',
  profileImage: 'user-service/reel/api/v1/user/edit-profileImage',
  deptDetail: '/production-service/reel/api/v2/dept/',
  updateDept: '/production-service/reel/api/v2/dept/',
  // updateDept: '/production-service/reel/api/v1/dept',
  riskUser: '/production-service/reel/api/v2/user-risk-permission',
  getDashboardPieData: '/shop-service/reel/api/v2/spending/top5/entity',
  banner: {
    getBannersList: 'banner-management',
    addBanner: 'client/add-banner',
    editBanner: 'client/edit-banner',
    deleteBanner: 'client/delete-banner',
    getShopBanner: 'shop-service/reel/api/v1/app/banner',
  },
  chat: {
    getQuote: 'vendor-service/api/v1/quotation/',
    createChat: 'vendor-service/api/v1/user/chat',
    employeeList: 'vendor-service/api/v1/user/chat/vendors',
  },
  dashBoard: {
    spendings: 'production-service/reel/api/v2/total-daily',
    spendingGraph: 'production-service/reel/api/v2/web/graph-all-data',
    deptDailySpeindgs: 'production-service/reel/api/v2/dept-total-daily',
    departmentLineChartdata:
      'production-service/reel/api/v2/web/dept-graph-all-data',
    departmentPaichartdata: `production-service/reel/api/v2/web/dept-top5Sets`,
    orderApprovers: '/production-service/reel/api/v2/roles/approvers',
    getOrderRoles: '/production-service/reel/api/v1/roles',
    getOrderApprovalLevels: '/production-service/reel/api/v2/approver-levels',
    approved: '/production-service/reel/api/v1/approver',
    addCrewMembers: '/production-service/reel/api/v1/member',
  },
  locationDetailsbanner: 'production-service/reel/api/v2/web/locations/',
  setDetailbanner: '/production-service/reel/api/v2/web/set/',
  // episodeDetailsBanner: '/production-service/reel/api/v1/web/episodes/',
  episodeDetailsBanner: '/production-service/reel/api/v2/web/episodes/',
  production: {
    setweblocations: 'production-service/reel/api/v1/web/set-locations',
    productiondetails: 'production-service/reel/api/v2/web/production/',
    dashboardGraph: (type: string, id: string, range = 'thisWeek') =>
      `production-service/reel/api/v1/graph-data?entityType=${type}&entityId=${id}&timeRange=${range}`,
    spendingGraph: (type: string, id: string, range = 'thisWeek') =>
      `production-service/reel/api/v2/web/graph-all-data?entityType=${type}&entityId=${id}&timeRange=${range}`,
    locationList: `production-service/reel/api/v1/web/production/active-set-locations`,
    locationWebList: `production-service/reel/api/v1/production/primary-shooting-locations`,
    departmentList: '/production-service/reel/api/v2/entity-depts',
    // crewmemberlist: 'production-service/reel/api/v1/members',
    crewmemberlist: 'production-service/reel/api/v2/members',
    setList: 'production-service/reel/api/v2/production/sets',
    setListWeb: '/production-service/reel/api/v2/web/production/sets',
    documentlist: 'production-service/reel/api/v2/documents',
    // documentlisrDept: '/production-service/reel/api/v1/documents-deptwise',
    documentlisrDept: '/production-service/reel/api/v2/documents-deptwise',
    // crewlistDept: '/production-service/reel/api/v1/members-deptwise',
    crewlistDept: '/production-service/reel/api/v2/members-deptwise',
    // productionDashList: '/production-service/reel/api/v1/productions',
    productionDashList: '/production-service/reel/api/v2/productions',
    productionNameList: '/production-service/reel/api/v2/production-names',
    userProfile: '/user-service/reel/api/v1/user/profile',
    crewdoccount:
      '/production-service/reel/api/v2/production/crew-document-count',
    setordercount:
      '/production-service/reel/api/v2/production/active-sets-orders',
    setOrders: '/shop-service/reel/api/v2/entity/order',
    productionList: (page = 1, limit = 10, searchKey = '') => {
      // Conditionally append searchKey if it's not empty
      const searchQuery = searchKey ? `&searchKey=${searchKey}` : '';
      return `production-service/reel/api/v1/productions?page=${page}&limit=${limit}${searchQuery}`;
    },
    productionsList: 'production-service/reel/api/v1/web/productions',
    productionsListV2: 'production-service/reel/api/v2/web/productions',
    episodelist: '/production-service/reel/api/v1/web/production/episodes',
    episodesRestricted:
      '/production-service/reel/api/v1/web/production/episodes-restricted',
    setsRestricted:
      '/production-service/reel/api/v2/production/sets-restricted',
    productionUpdate: (id: string) =>
      `production-service/reel/api/v2/production/${id}`,
    emailuniqueness: '/production-service/reel/api/v1/check-email',
    checkStudioUniqueName: '/production-service/reel/api/v1/check-studio-name',
    // spendingPiaChartData: '/production-service/reel/api/v1/custom-filter',
    spendingPiaChartData: '/production-service/reel/api/v2/custom-filter',
    studioPiaChartData:
      '/production-service/reel/api/v2/web/studio/top5Productions',
    totalSets: '/production-service/reel/api/v1/web/studio-sets',
    locationAndEpisodePiaChartData:
      'production-service/reel/api/v2/web/top5Sets',
    productionEpisodeTop5:
      'production-service/reel/api/v2/web/production/top5Episodes',
  },
  set: {
    // setDashList: '/production-service/reel/api/v1/sets',
    setDashList: '/production-service/reel/api/v2/sets',
    sets: '/production-service/reel/api/v1/web/sets',
    setDetails: 'production-service/reel/api/v1/set',
    // createSet: 'production-service/reel/api/v1/web/set',
    createSet: 'production-service/reel/api/v2/set',
    departmentList:
      '/production-service/reel/api/v2/entity-depts?entityType=sets',
    setList: 'production-service/reel/api/v1/sets',
    episodeListByProduction:
      '/production-service/reel/api/v2/production/episode-names',
    setLocation: `production-service/reel/api/v1/set-locations`,
    setWebLocations: `production-service/reel/api/v1/set-primary-locations`,
    setLocationsRestricted:
      '/production-service/reel/api/v2/set-locations-restricted',
    setTopFiveLocationSpending: `production-service/reel/api/v2/web/set/top5Locations`,
    copySet: '/production-service/reel/api/v1/reuse-set',
  },
  episode: {
    // episodeDashList: '/production-service/reel/api/v1/web/episodes',
    episodeDashList: '/production-service/reel/api/v2/episodes',
    episodeLists: '/production-service/reel/api/v1/web/episodes',
    episodeListsV2: '/production-service/reel/api/v2/web/episodes',
    episodeDetails: 'production-service/reel/api/v1/episodes',
    episodeScheduleStatus:
      '/production-service/reel/api/v1/calculate-episode-schedule-status',
    createepisode: '/production-service/reel/api/v1/episode',
    // createEpisode: '/production-service/reel/api/v1/web/episode',
    createEpisode: '/production-service/reel/api/v2/episode',
    getbaserole: 'production-service/reel/api/v1/static-roles',
    getbaseroles: 'production-service/reel/api/v1/static-role',
    getEpisodeTopFiveSets: 'production-service/reel/api/v2/web/top5Sets',
  },
  location: {
    // locationDashList: '/production-service/reel/api/v1/locations',
    locationDashList: '/production-service/reel/api/v2/locations',
    myLocationList: '/production-service/reel/api/v1/locations',
    locationDetailList: 'production-service/reel/api/v1/locations/',
    locationsetslist:
      '/production-service/reel/api/v1/web/locations/related-sets',
    locationassociatedlist:
      '/production-service/reel/api/v1/locations/associated-sets',
    locationAssociatedlistWeb:
      '/production-service/reel/api/v1/web/locations/associated-sets',
    cretaelocation: '/production-service/reel/api/v1/location',
    // createLocation: '/production-service/reel/api/v1/web/location',
    createLocation: '/production-service/reel/api/v2/location',
    episodelist: '/production-service/reel/api/v2/production/episode-names',
    setlist: '/production-service/reel/api/v2/production/set-names',
    setLocationList: '/production-service/reel/api/v1/location-active-sets',
  },
  memberIdDetail: '/user-service/reel/api/v2/user/associated_entities',
  studio: {
    // studioDetail: '/production-service/reel/api/v1/web/studio-detail',
    studioDetail: '/production-service/reel/api/v2/studio-detail',
    activestudiolocations:
      '/production-service/reel/api/v1/web/studio/active-production-addresses',
    studioProductions: '/production-service/reel/api/v2/studios/productions',
    studioProductionsRestricted:
      '/production-service/reel/api/v2/studios/productions-restricted',
    studiosets: '/production-service/reel/api/v1/web/studio-sets',
    studioLocationsAll: '/production-service/reel/api/v1/web/studio-locations',
    studioEpisodesAll: '/production-service/reel/api/v1/web/studio-episodes',
    studiolist: 'production-service/reel/api/v2/studios/productions',
    studiodashlist: '/production-service/reel/api/v1/studios',
    // AllStudiolist: 'production-service/reel/api/v1/studios',
    AllStudiolist: 'production-service/reel/api/v2/studios',
    checkUserwithPhoneNumber: 'production-service/reel/api/v1/user',
    userNames: (searchKey: string, page = 1, limit = 10) =>
      `production-service/reel/api/v1/user-names?searchKey=${encodeURIComponent(
        searchKey,
      )}&page=${page}&limit=${limit}`,
    // createStudio: 'production-service/reel/api/v1/studio',
    createStudio: 'production-service/reel/api/v2/studio',
    updateStudio: 'production-service/reel/api/v1/studio',
    spendingProductions:
      'production-service/reel/api/v2/studio/spendingProductions',
    studioLocations:
      'production-service/reel/api/v1/studios/active-production-locations',
    getEntityDeps: '/production-service/reel/api/v2/entity-depts',
    getStudioRoleList: '/production-service/reel/api/v2/user/role-list',
    getRoleDetails: '/production-service/reel/api/v2/user',
    addContact: '/production-service/reel/api/v2/user/add-contact',
    staticRoles: '/production-service/reel/api/v2/user/static-roles',
    getEntityCount: '/production-service/reel/api/v2/user/entity-count',
    addRole: '/production-service/reel/api/v2/user/add-role',
    checkUniqueMember: '/production-service/reel/api/v2/member-unique-check',
    updateContacts: '/production-service/reel/api/v2/member/',
  },
  staticContentManagement: {
    getStaticContent: 'client/get-static-content',
    getFAQ: 'client/faq',
    getAddContactInfo: 'client/contact-info',
    addStaticContent: 'client/add-static-content',
    editStaticContent: 'client/edit-static-content',
    addContactInfo: 'client/add-contact-info',
  },
  order: {
    getShifts: '/shop-service/reel/api/v1/app/shifts',
    addCart: '/shop-service/reel/api/v1/cart',
    editShiftInPreview: 'shop-service/reel/api/v1/preview-shift/edit-cart',
    shiftNotes: '/shop-service/reel/api/v1/order/notes',
    editShift: 'shop-service/reel/api/v1/cart/edit-cart',
    orderList: '/shop-service/reel/api/v2/order',
    orderRequest: '/shop-service/reel/api/v1/approval/orders',
    vendorRequest: '/shop-service/reel/api/v1/vendor-order/approval/orders',
    getOrderDetails: '/shop-service/reel/api/v1/order',
    getOrderTracking: 'shop-service/reel/api/v1/order/track',
    getDepartmentList: '/production-service/reel/api/v2/my-production-depts',
    updateOrderStatus:
      '/production-service/reel/api/v2/approval/orders/approve-reject',
    updateVendorOrderStatus:
      '/production-service/reel/api/v2/vendor-order/approve-reject',
    editShiftInOrder: 'shop-service/reel/api/v1/order/edit-order',
    updateLocation: '/shop-service/reel/api/v1/order/set-locations',
    reportProblem: '/shop-service/reel/api/v1/order/report',
    approveReject: 'shop-service/reel/api/v1/order/order-updates-approval',
    addComment: '/production-service/reel/api/v1/vendor-order/comment',
    getWorksheetDataInvoice: '/invoice-service/reel/api/v1/client/invoices',
    getWorksheetNotes: '/invoice-service/reel/api/v1/client/invoices/shifts',
    getPaymentHistory: '/shop-service/reel/api/v2/user/payment-history',
    invoices: '/invoice-service/reel/api/v1/client/invoices',
    invoiceSpending: '/invoice-service/reel/api/v1/client/invoices/spending',
    invoiceRequests:
      '/invoice-service/reel/api/v1/client/invoices/approval-status',
    invoiceRequestsRejected:
      '/invoice-service/reel/api/v1/client/invoices/rejected-query-raised',
    deleteShift: '/shop-service/reel/api/v1/cart/shifts',
    cancelShift: '/shop-service/reel/api/v1/order/shifts',
    deleteItem: '/shop-service/reel/api/v1/order/cancel',
    cancelOrderItems: '/shop-service/reel/api/v1/cancel-order/items',
    orderInvoiceListing: '/invoice-service/reel/api/v1/client/orders',
    receipt: '/invoice-service/reel/api/v1/client/invoices',
    returnRequestItems: '/shop-service/reel/api/v1/order/return-request',
    returnRequestList: '/shop-service/reel/api/v1/return-request/return-list',
    returnItem: '/shop-service/reel/api/v1/order/return-request',
    getUpdatedShifts: '/shop-service/reel/api/v1/order',
    cancelReturnRequest:
      '/shop-service/reel/api/v1/order/cancel-return-request',
    raiseDisputeItemList: '/shop-service/reel/api/v1/order/raise-dispute-list',
    raiseDispute: '/shop-service/reel/api/v1/order/raise-dispute',
    poNumber: '/shop-service/reel/api/v1/cart/poNumber',
    orderPermission: '/shop-service/reel/api/v1/app/permissions',
    addApproverLevel:
      '/production-service/reel/api/v2/production-approval-level',
    worksheetItems: '/shop-service/reel/api/v2/order/worksheet/items',
    worksheetSummary: '/shop-service/reel/api/v2/order/worksheet/summary',
  },
  productionManagement: {
    // createProduction: 'production-service/reel/api/v1/web/production',
    createProduction: 'production-service/reel/api/v2/production',
    productionStatus: 'production/status',
    department: 'department',
    updateEpisode: (id: string) => `production/episode/${id}`,
    updateSet: (id: string) => `production/episode/set/${id}`,
  },

  verify: 'user-service/reel/api/v1/user/verify-otp',
  verifyFirebaseotp: '/user-service/reel/api/v1/user/verify-otp-with-firebase',
  businessRegister: 'business/registration',
  common: {
    deparmentList: 'dept-list',
    countryList: '/country',
    categories: 'category/list',
    studioList: 'studios',
    addNewJobTitle: '/user-service/reel/api/v1/user/add-role',
  },
  product: {
    create: '/template',
    list: '/template',
  },

  commonApi: {
    countryList: '/country',
  },
  department: '/depts',
  companyManagement: {
    getUserDetailsWithPhone: 'mobile/user',
    getCompnayList: '/studio',
    updateStatus: 'studio/status',
    create: '/studio',
  },
  // update these notification
  notification: {
    updateDeviceToken: 'notification-service/reel/api/v1/admin/apns/token',
    updateDeviceTokenFCM: '/notification-service/reel/api/v1/user/apns/token',
    notifications: 'notification-service/reel/api/v1/user/notifications',
    unreadCount: '/notification-service/reel/api/v1/user/notifications-count',
    checkAccess: '/production-service/reel/api/v1/check-access',
    checkAccessV2: '/production-service/reel/api/v2/entity-access-check',
  },
  staticData: {
    content: `user-service/reel/api/v1/user/static-content`,
    contentfaq: `user-service/reel/api/v1/user/web/`,
  },
  webOrder: '/production-service/reel/api/v1/web/order',
  riskCenter: {
    activeEventsAndAdvisor:
      '/production-service/reel/api/v1/risk-center/active-events-advisors-count',
    branchdetails: (id: string) =>
      `/shop-service/reel/api/v1/app/branches/${id}`,
    vendorGroups: (id: string) =>
      `/shop-service/reel/api/v1/app/vendor-groups?branchId=${id}`,
    vendorServiceLists: (id: string) =>
      `/shop-service/reel/api/v1/app/vendor-services?isRiskCenter=true&branchId=${id}
`,
    serviceDetails: (id: string) =>
      `/shop-service/reel/api/v1/app/service/${id}`,

    serviceDetailsimilar:
      '/shop-service/reel/api/v1/app/service?latitude=28.6067511&longitude=77.3597194&department=65bc021710e3620112fd42f4&limit=10&page=1',
    productionLocations:
      '/production-service/reel/api/v1/studios/active-production-locations',
    productions: '/production-service/reel/api/v2/studios/productions',
    userTypeContactList:
      '/production-service/reel/api/v1/risk-center/user-type-contact-list',
    contactList: '/production-service/reel/api/v1/risk-center/contact-list',
    addUserType: '/production-service/reel/api/v1/risk-center/user-type',
    addtoCart: '/shop-service/reel/api/v1/cart',
    orderList: '/shop-service/reel/api/v1/risk-center/orders',
    accessList: '/production-service/reel/api/v1/risk-center/access-management',
    updateAccessList:
      '/production-service/reel/api/v1/risk-center/access-management',
    businessAddress: '/user-service/reel/api/v2/user/address',
    checkDeliverability: '/shop-service/reel/api/v1/cart/check-deliverability',
    schedules: '/production-service/reel/api/v2/schedules',
    addToCart: '/shop-service/reel/api/v1/cart',
    cart: '/shop-service/reel/api/v1/cart',
    manageDeptList: '/production-service/reel/api/v1/manage-dept',
    shiftDetail: '/shop-service/reel/api/v1/worksheets',
    updateProducts: '/shop-service/reel/api/v1/cart/products',
    order: '/shop-service/reel/api/v2/order',
    draft: '/shop-service/reel/api/v1/user/draft',
    addDescription: '/shop-service/reel/api/v1/cart/description',
    bookCabService: '/shop-service/reel/api/v1/booking',
    bookingDetails: (id: string) => `/shop-service/reel/api/v1/booking/${id}`,
    userDetailsByProduction: (id: string) =>
      `/shop-service/reel/api/v1/risk-center/user-detail-by-production?productionId=${id}`,
  },
  riskSecurity: {
    studioDashOverview:
      '/production-service/reel/api/v1/studio-dashboard/{studioId}/overview',
    studioDashAnalytics:
      '/production-service/reel/api/v1/studio-dashboard/{studioId}/analytics-overview',
    studioDashLocations:
      '/production-service/reel/api/v1/studio-dashboard/{studioId}/locations-overview',
    studioDashProductions:
      '/production-service/reel/api/v1/studio-dashboard/{studioId}/productions-threats',
    studioDashDaywiseThreats:
      '/production-service/reel/api/v1/studio-dashboard/{studioId}/threat-trend',
    studioDashLocationThreats:
      '/production-service/reel/api/v1/studio-dashboard/{studioId}/threats-by-location',
    getOrganizations: '/production-service/reel/api/v2/organization',
    getThreatSubCategory:
      '/production-service/reel/api/v1/quick-threat-subcategories',
    saveDraft: '/production-service/reel/api/v1/vulnerability-report',
    getOrganizationsReporter:
      '/production-service/reel/api/v2/organization-reporters',
    getThreatType: '/production-service/reel/api/v1/quick-threat-types',
    saveDraftAlert: '/production-service/reel/api/v1/quick-threat-report',
    getDraftList: '/production-service/reel/api/v1/draft-reports',
    getDraftDetail: '/production-service/reel/api/v1/draft-report',
    productionDashboardOverview:
      '/production-service/reel/api/v1/production-dashboard/{productionId}/overview',
    productionDashboardAnalytics:
      '/production-service/reel/api/v1/production-dashboard/{productionId}/analytics-overview',
    productionDashboardLocations:
      '/production-service/reel/api/v1/production-dashboard/{productionId}/locations-overview',
    productionDashboardSetThreats:
      '/production-service/reel/api/v1/production-dashboard/{productionId}/sets-threats',
    productionDashboardDaywiseThreats:
      '/production-service/reel/api/v1/production-dashboard/{productionId}/threat-trend',
    productionDashboardLocationThreats:
      '/production-service/reel/api/v1/production-dashboard/{productionId}/threats-by-location',
    episodeDashboardOverview:
      '/production-service/reel/api/v1/episode-dashboard/{episodeId}/overview',
    episodeDashboardAnalytics:
      '/production-service/reel/api/v1/episode-dashboard/{episodeId}/analytics-overview',
    episodeDashboardLocations:
      '/production-service/reel/api/v1/episode-dashboard/{episodeId}/locations-overview',
    episodeDashboardSetThreats:
      '/production-service/reel/api/v1/episode-dashboard/{episodeId}/sets-threats',
    episodeDashboardDaywiseThreats:
      '/production-service/reel/api/v1/episode-dashboard/{episodeId}/threat-trend',
    episodeDashboardLocationThreats:
      '/production-service/reel/api/v1/episode-dashboard/{episodeId}/threats-by-location',
    setDashboardOverview:
      '/production-service/reel/api/v1/set-dashboard/{setId}/overview',
    setDashboardAnalytics:
      '/production-service/reel/api/v1/set-dashboard/{setId}/analytics-overview',
    setDashboardLocations:
      '/production-service/reel/api/v1/set-dashboard/{setId}/locations-overview',
    setDashboardLocationsCards:
      '/production-service/reel/api/v1/set-dashboard/{setId}/locations-threats',
    setDashboardDaywiseThreats:
      '/production-service/reel/api/v1/set-dashboard/{setId}/threat-trend',
    setDashboardLocationThreats:
      '/production-service/reel/api/v1/set-dashboard/{setId}/threats-by-location',
    locationDashOverview:
      '/production-service/reel/api/v1/location-dashboard/{locationId}/overview',
    locationThreatAlerts:
      '/production-service/reel/api/v1/location-dashboard/{locationId}/threats',
    locationThreatDetail:
      '/production-service/reel/api/v1/location-dashboard/{locationId}/threats/{classificationId}',
    updateThreatAlert:
      '/production-service/reel/api/v1/location-dashboard/{locationId}/threats/{classificationId}',
    acknowledgeThreat:
      '/production-service/reel/api/v1/location-dashboard/{locationId}/threats/{classificationId}/acknowledge',
    checkAlreadyCreated:
      '/production-service/reel/api/v1/location-dashboard/check-vulnerability-form',
    exportPdf:
      '/production-service/reel/api/v1/vulnerability-report/{reportId}/export-pdf',
    locationWithActive:
      '/production-service/reel/api/v1/dashboard/{dashboardType}/{entityId}/active-critical-locations',
    setRisklocations:
      'production-service/reel/api/v1/web/threat-form/set-locations',
    userAccess: '/production-service/reel/api/v2/entity-access',
    threatList:
      '/production-service/reel/api/v1/dashboard/{dashboardType}/{entityId}/threats',
    threatDetail:
      '/production-service/reel/api/v1/dashboard/{dashboardType}/{entityId}/threats/{classificationId}',
  },

  store: {
    userDepartmentsCategories:
      'shop-service/reel/api/v1/app/user-departments-categories',
    preferredVendors: 'shop-service/reel/api/v1/app/my-favorites',
    vendorsList: 'shop-service/reel/api/v1/app/preferred-vendors',
    products: 'shop-service/reel/api/v1/app/products',
    services: 'shop-service/reel/api/v1/app/services',
    packages: 'shop-service/reel/api/v1/packages',
    favorites: '/shop-service/reel/api/v1/app/my-favorites',
    addToFavorites: '/shop-service/reel/api/v1/app/favorite-toggle',
    getserviceDetails: '/shop-service/reel/api/v1/app/service/',
    getPacakgeDetails: '/shop-service/reel/api/v1/packages/',
    getVendorDetails: '/shop-service/reel/api/v1/app/vendor',
    getVendorDetailsCategories: '/shop-service/reel/api/v1/app/vendor/',
    getVendorDetailGrops: '/shop-service/reel/api/v1/app/vendor-groups',
    getVendorDetailProducts: '/shop-service/reel/api/v1/app/vendor-products',
    getVendorDetailServices: '/shop-service/reel/api/v1/app/vendor-services',
    addDeparment: '/shop-service/reel/api/v1/app/departments',
    groupDetail: '/shop-service/reel/api/v1/product/groups/',
    vendorRequest: '/shop-service/reel/api/v1/app/vendor-request',
  },
  myDocuments: {
    myDocumentsList: 'production-service/reel/api/v2/production-documents',
    recentDocument: 'production-service/reel/api/v2/my-documents',
    myDocumentDeptWise: 'production-service/reel/api/v2/my-documents-dept-wise',
    locationList: 'production-service/reel/api/v1/document-location-names',
    setlist: '/production-service/reel/api/v1/document-set-names',
    episodelist: '/production-service/reel/api/v1/document-episode-names',
    filterList: 'production-service/reel/api/v2/entity-document-list',
    deleteDocument: 'production-service/reel/api/v2/documents',
  },
  schedule: {
    // scheduleList: 'production-service/reel/api/v1/schedule-list',
    scheduleList: 'production-service/reel/api/v2/schedule-list',
    scheduleFilter: 'production-service/reel/api/v1/schedule-filter-list',
    scheduleCalendar: 'production-service/reel/api/v2/schedule-calendar',
    entityScheduleFilter:
      'production-service/reel/api/v2/entity-schedule-filter-list',
  },
  spending: {
    entitySpendings:
      '/production-service/reel/api/v2/web/studio-entity-spending',
    spendingOrder: '/production-service/reel/api/v2/filter-finance-order',
    departmentSpendingOrder: '/production-service/reel/api/v1/finance-order',
    entityList: '/production-service/reel/api/v2/web/spending-list',
    departmentSpendings: 'production-service/reel/api/v1/dept-total-daily',
    departmentGraphSpendings:
      '/production-service/reel/api/v1/web/dept-graph-all-data',
    filterTotalDaily: '/production-service/reel/api/v2/filter-total-daily',
    filterGraphAll: '/production-service/reel/api/v2/web/filter-graph-all-data',
    financeWorksheet: '/production-service/reel/api/v2/finance/worksheet',
    financeWorksheetV2: '/production-service/reel/api/v2/finance/new-worksheet',
    financeWorksheetShifts:
      '/production-service/reel/api/v2/finance/worksheet-shifts',
    financeWorksheetShiftNotes:
      '/production-service/reel/api/v2/finance/worksheet-shift-notes',
    financeWorksheetOrderNotes:
      '/production-service/reel/api/v2/finance/worksheet-order-notes',
    financeWorksheetOrderProducts:
      '/production-service/reel/api/v2/finance/worksheet-order-products',
    financeAddOnCharges:
      '/production-service/reel/api/v2/finance/add-on-charges',
  },
  chatModule: {
    searchChat: 'chat-service/reel/api/v1/search',
    getGroupEntities: '/chat-service/reel/api/v1/user/chat/associated_entities',
    entityMembersList: '/chat-service/reel/api/v1/user/chat/entity/member-list',
    createGroup: '/chat-service/reel/api/v1/user/chat/user-group',
    createAutomatedGroup: `/chat-service/reel/api/v1/user/chat/automated-group`,
    createDepartmentGroup:
      '/chat-service/reel/api/v1/user/chat/department-group',
    createRiskChat: '/chat-service/reel/api/v1/user/chat/risk-center-group',
    updateGroup: '/chat-service/reel/api/v1/user/chat/user-group',
    groupDetails: '/chat-service/reel/api/v1/user/chat/group/member-list',
    createChat: '/chat-service/reel/api/v1/user/chat',
    raiseQuery: 'invoice-service/reel/api/v1/client/invoices',
    getDocuments: (chatId: string) =>
      `/chat-service/reel/api/v1/user/chat/${chatId}/media`,
    blockList:
      'chat-service/reel/api/v1/user/chat/blocked-contacts?pageNo=1&limit=100',
  },
  cart: {
    cartSetList: '/shop-service/reel/api/v1/addresses',
    updateLocation: 'shop-service/reel/api/v1/cart/set-locations',
    getLocation: 'production-service/reel/api/v2/set-locations',
    getLocationCount: '/shop-service/reel/api/v1/cart/services/locations',
    getSetAddresses: '/user-service/reel/api/v2/user/address',
    addItems: '/shop-service/reel/api/v1/cart/add-items',
    orderAddItems: '/shop-service/reel/api/v1/order/add-items',
    validatePoNumber:
      '/shop-service/reel/api/v1/cart/poNumber/check-association',
  },
  payment: {
    //Stripe endpoints
    getSavedCards: '/payment-service/reel/api/v1/user/card',
    saveCard: '/payment-service/reel/api/v1/user/card',
    makeCardPayment: '/payment-service/reel/api/v1/user/card-payment',

    //ACH endpoints
    getPlaidToken: '/payment-service/reel/api/v1/plaid-link-token',
    getSavedBankAccounts: '/payment-service/reel/api/v1/user/bank-account',
    addBankAccount: '/payment-service/reel/api/v1/user/bank-account',
    deleteBankAccount: '/payment-service/reel/api/v1/user/bank-account',
    makeAchPayment: '/payment-service/reel/api/v1/user/ach-payment',
    invoiceACHPayment: '/payment-service/reel/api/v1/user/invoice-ach-payment',
    invoiceCardPayment:
      '/payment-service/reel/api/v1/user/invoice-card-payment',
  },
};

export default endPoints;
